import React from 'react';
import './AddLeadFrom.css';
import Button from '../common/Button/Button';
import Header from '../common/Header/Header';

const AddLeadForm = ({
  showAddForm,
  newLeadFormData,
  handleNewLeadChange,
  showContactDropdown,
  filteredContacts,
  handleContactSelect,
  contactSearch,
  setShowContactFormCallback,
  setShowContactDropdown,
  showCompanyDropdown,
  filteredCompanies,
  handleCompanySelect,
  showProductDropdown,
  filteredProducts,
  handleProductSelect,
  handleAddNewLead,
  isLoading,
  handleToggleAddForm,
  showContactForm,
  newContactData,
  setNewContactData,
  handleAddNewContact,
  showNewProductForm,
  setShowNewProductForm,
  newProductData,
  setNewProductData,
  showCompanyForm,
  setShowCompanyForm,
  newCompanyData,
  setNewCompanyData,
  handleAddNewCompany,
  handleContactNameChange,
  handleCompanyNameChange,
  handleProductNameChange,
  setShowCompanyDropdown,  // Add this
  companySearch,           // Add this
  setShowProductDropdown,  // Add this
  productSearch,closePopup
}) => {
  if (!showAddForm) return null;

  return (
    <div className="addLead-modal-overlay">
      <div className="addLead-modal-content">
        <div className="popup-header">
          <Header title="Add New Lead" />
          <Button onClick={closePopup} className="close-btn top-right" title="Close">×</Button>
        </div>
      
        <div className="popup-body">
          <div className="popup-grid">
            {/* Details Section */}
                <div className="details-section">
                  <h4>Lead Details</h4>
                  <div className="addLead-addLead-form-group">
                    <label>Lead Id:</label>
                    <input
                      type="text"
                      name="lead_id"
                      value={newLeadFormData.lead_id}
                      onChange={handleNewLeadChange}
                      required
                    />
                  </div>

                  <div className="addLead-addLead-form-group">
                    <label>Product Name:</label>
                    <input
                      type="text"
                      name="product_name"
                      value={newLeadFormData.product_name}
                      onChange={handleProductNameChange}
                      onFocus={() => setShowProductDropdown(true)}
                    />
                    {showProductDropdown && (
                      <div className="contact-dropdown">
                        {filteredProducts.length > 0 ? (
                          filteredProducts.map(product => (
                            <div 
                              key={product.id} 
                              className="contact-option"
                              onClick={() => handleProductSelect(product)}
                            >
                              {product.name}
                            </div>
                          ))
                        ) : (
                          <div 
                            className="contact-option add-new"
                            onClick={() => {
                              setShowNewProductForm(true);
                              setShowProductDropdown(false);
                            }}
                          >
                            + Add New Product: "{productSearch}"
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="addLead-form-group">
                    <label>Specification:</label>
                    <input
                    type="text"
                    name="specifications"
                    value={newLeadFormData.specifications}
                    onChange={handleNewLeadChange}
                    />
                  </div>
                  <div className="addLead-form-group">
                    <label>Source:</label>
                    <input
                      type="text"
                      name="source"
                      value={newLeadFormData.source || ''}
                      onChange={handleNewLeadChange}
                    />
                  </div>

                  <div className="addLead-form-group">
                    <label>Delivery Location:</label>
                    <input
                      type="text"
                      name="delivery_location"
                      value={newLeadFormData.delivery_location}
                      onChange={handleNewLeadChange}
                    />
                  </div>
                  <div className="addLead-form-group">
                    <label>Response Notes:</label>
                    <textarea
                      name="response_notes"
                      value={newLeadFormData.response_notes}
                      onChange={handleNewLeadChange}
                    />
                  </div>
                </div>
               {/* contact Section */}
                <div className="contact-info-section">
                  <h4>Contact Information</h4>
                  <div className="addLead-form-group">
                    <label>Contact Name:</label>
                    <input
                      type="text"
                      name="contact_name"
                      value={newLeadFormData.contact_name}
                      onChange={handleContactNameChange}
                      onFocus={() => setShowContactDropdown(true)}
                    />
                    {showContactDropdown && (
                      <div className="contact-dropdown">
                        {filteredContacts.length > 0 ? (
                          filteredContacts.map(contact => (
                            <div 
                              key={contact.contact_id} 
                              className="contact-option"
                              onClick={() => handleContactSelect(contact)}
                            >
                              {contact.name} - {contact.company || contact.phone || contact.email || 'No info'}
                            </div>
                          ))
                        ) : (
                          <div 
                            className="contact-option add-new"
                            onClick={() => {
                              setShowContactFormCallback(true);
                              setShowContactDropdown(false);
                            }}
                          >
                            + Add New Contact: "{contactSearch}"
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="addLead-form-group">
                    <label>Company Name:</label>
                    <input
                      type="text"
                      name="company_name"
                      value={newLeadFormData.company_name}
                      onChange={handleCompanyNameChange}
                      onFocus={() => setShowCompanyDropdown(true)}
                    />
                    {showCompanyDropdown && (
                      <div className="contact-dropdown">
                        {filteredCompanies.length > 0 ? (
                          filteredCompanies.map(company => (
                            <div 
                              key={company.id} 
                              className="contact-option"
                              onClick={() => handleCompanySelect(company)}
                            >
                              {company.name} - {company.city || ''} {company.country || ''}
                            </div>
                          ))
                        ) : (
                          <div 
                            className="contact-option add-new"
                            onClick={() => {
                              setShowCompanyForm(true);
                              setShowCompanyDropdown(false);
                              setNewCompanyData(prev => ({
                                ...prev,
                                name: companySearch
                              }));
                            }}
                          >
                            + Add New Company: "{companySearch}"
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  <div className="addLead-form-group">
                    <label>Phone:</label>
                    <input
                      type="text"
                      name="contact_phone"
                      value={newLeadFormData.contact_phone}
                      onChange={handleNewLeadChange}
                    />
                  </div>
                  <div className="addLead-form-group">
                    <label>Email:</label>
                    <input
                      type="email"
                      name="contact_email"
                      value={newLeadFormData.contact_email}
                      onChange={handleNewLeadChange}
                    />
                  </div>
                </div>

            </div>
            <div className="modal-buttons">
            <button
              onClick={handleAddNewLead}
              disabled={isLoading}
              className="add-button"
            >
              {isLoading ? "Adding..." : "Add Lead"}
            </button>
            <button
              onClick={handleToggleAddForm}
              disabled={isLoading}
              className="cancel-button"
            >
              Cancel
            </button>
          </div>
          </div>
        </div>
        </div>

  );
};

export default AddLeadForm;
